// PRD 16 LR16 (LR10 verdict U-B) — the user page's tabs under the profile: „Children (n)” first for a parent — or for an account
// whose panel holds a row without the Parent persona, whose children didn't load, or whose last child just left (`keepChildren`),
// so no child and no outcome is ever lost — „Player” only for a player, then what every account has. A parent's page opens on the
// children, a player's on the player's tab. `rows` are the panel's rows, `children` the children among them (n counts those).
import { holdsPersona } from "../personas"

export const profileTabs = ({ account, rows, children, keepChildren = false }) => {
  const parent = holdsPersona(account, "parent")
  const player = holdsPersona(account, "player")
  const tabs = [
    ...(parent || keepChildren || rows?.length ? [{ id: "children", label: children ? `Children (${children.length})` : "Children" }] : []),
    ...(player ? [{ id: "player", label: "Player" }] : []),
    { id: "activity", label: "Account activity" },
    { id: "entries", label: "Tournament entries" },
    { id: "membership", label: "Membership" },
    { id: "orders", label: "Orders" },
    { id: "wallet", label: "Wallet" },
  ]
  return { tabs, defaultTab: parent ? "children" : player ? "player" : "activity" }
}

// a passport still in force: active, or active and ending soon
const IN_FORCE = ["active", "expiring"]
export const activePassports = children => (children || []).filter(child => IN_FORCE.includes(child.passport?.state)).length
